import React, { useState } from 'react';
import { Modal, Button, Paper, withStyles } from '@material-ui/core';
import iconClient from './images/iconClient.png';

const styles = {
  modalStyle: {
    position: 'absolute',
    width: 391,
    height: 325,
    top: 145,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'white',
    borderRadius: 24,
    padding: '20px',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  }
};

const ModalUserNotFound = ({ classes, open, setOpen, resetForm }) => {
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    resetForm()
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Paper className={classes.modalStyle}>
          <img src={iconClient} alt="Icono de cliente" style={{ width: '100px', height: '100px' }} />
          <span
            style={{ fontFamily: 'Sura Sans', fontSize: '22px', color: '#0033A0', fontWeight: 600, marginTop: '10px' }}
          >
            Registro no Encontrado
          </span>
          <span style={{ fontFamily: 'Sura Sans', fontSize: '16px', color: '#0033A0', textAlign: 'left',marginTop: '7px' }}>
          No contamos con registro de la póliza que deseas buscar, por favor intenta nuevamente
          </span>
          <div
            onClick={handleClose}
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '92px',
              height: '40px',
              borderRadius: '28px',
              border: '1px solid #0133A0',
              fontFamily: 'Sura Sans',
              fontSize: '16px',
              color: '#0133A0',
              justifySelf:'flex-end',
              marginTop: 'auto'
            }}
          >
            Aceptar
          </div>
        </Paper>
      </Modal>
    </div>
  );
};

export default withStyles(styles)(ModalUserNotFound);



// WEBPACK FOOTER //
// ./src/containers/client/ModalUserNotFound.js